import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

//import React from 'react';
//import ReactDOM from 'react-dom/client';
//import './index.css';
//
//function App() {
//  return (
//    <div className="maintenance-container">
//      <div className="maintenance-content">
//        <h1>🚧 Under Maintenance</h1>
//        <p>We are currently performing scheduled maintenance to improve your experience.</p>
//        <p>We should be back online shortly. Thank you for your patience!</p>
//        <div className="loading-spinner"></div>
//        <small>— The Team</small>
//      </div>
//    </div>
//  );
//}
//
//const root = ReactDOM.createRoot(document.getElementById('root'));
//root.render(
//  <React.StrictMode>
//    <App />
//  </React.StrictMode>
//);